import { getPrivacy, getTerms, getWarnings } from '../../../helpers/api'

export default {
	getPrivacyPage: ({ commit }, { locale }) => {
		commit('SET_LOADING', true)
		return getPrivacy(locale).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_PRIVACY', data.content)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	getTermsPage: ({ commit }, { locale }) => {
		commit('SET_LOADING', true)
		return getTerms(locale).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_TERMS', data.content)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	getWarningsPage: ({ commit }, { locale }) => {
		commit('SET_LOADING', true)
		return getWarnings(locale).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_WARNINGS', data.content)
			return true
		}).catch((err) => {
			commit('SET_LOADING', false)
			console.error(err.message)
		})
	},
	setLocale: ({ commit }, { locale }) => {
		commit('SET_LOCALE', locale)
		commit('SET_PRIVACY', '')
		commit('SET_TERMS', '')
		commit('SET_WARNINGS', '')
	}
}
